/* eslint-disable import/prefer-default-export */
import { LOG_IN } from '../types';

export const setProfile = (data) => (dispatch) =>
  dispatch({
    type: LOG_IN,
    payload: data,
  });
